// extracted by mini-css-extract-plugin
export default {"noMarginTop":"KNp0P"};